import { animate, style, transition, trigger } from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewChildren,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { AppService, InterviewService, MonitoringService } from '@App';
import { CaseAssignee, ClientUser, ManagementQueue, ManagementQueueResult, SearchCasesResults, UWResponse } from '@Models';
import { ConfirmationDialogData } from 'app/components/confirmation-dialog/confirmation-dialog.component';
import {
    MultiSelectDropdownListComponent,
} from 'app/components/multi-select-dropdown-list/multi-select-dropdown-list.component';
import { IConfigService } from 'app/config/iconfigservice';
import { Clients, FeatureToggle, MrsColor, RolesEnum } from '@Enums';
import { IGetNextCase } from 'app/models/case/case-get-next-case.interface';
import { FeatureManagerService } from 'app/services/global/feature-manager/feature-manager.service';
import $ from 'jquery';
import * as _ from 'lodash';
import { forkJoin, Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink';

import { Utils } from '@Utils';
import { SharedModule } from '@Shared/shared.module';
import { RemoveHtmlTagsPipe } from '@Pipes/removehtmltags.pipe';
import { FilterExactPipe } from '@Pipes/filter-exact.pipe';
import { FilterNullPipe } from '@Pipes/filter-null.pipe';
import { NotesDialogComponent } from '@App/management-queues/notes-dialog.component';
import { ManagementQueueUpdates } from '@CNBW/models/ManagementQueueConfigModel.interface.tx';
import { NewBusinessWorkbenchStateService, NewBusinessWorkbenchService } from '@CNBW/services';
import { MultiSelectModel } from '@Components/multi-select-dropdown-list/models/MultiSelectModel.interface';
import { RoutingService, ClientService, CaseAssigneeService, NotificationService, UtilityService, GlobalService, CaseSummaryService, ConfirmationDialogService, ManagementQueueService, RoutesEnum, NotificationSeverity } from '@Services';
import { CaseSortWorkerService } from './case-sort-worker.service';
import { computeSortedIndexes, getCaseSortKey } from './case-sort.utils';

@Component({
    selector: 'view-queues-optimized',
    host: { 'class': 'overflow-content' },
    templateUrl: 'view-queues.component.html',
    styleUrls: ['view-queues.component.scss'],
    animations: [
        trigger('flyRightToLeft', [
            transition(':enter', [
                style({ transform: 'translateX(-100%)' }),
                animate(250),
                animate('10ms', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate(200, style({ transform: 'translateX(-100%)' })),
                animate('10ms', style({ opacity: 0 }))
            ])
        ])
    ],
    imports: [SharedModule, RemoveHtmlTagsPipe, FilterExactPipe, FilterNullPipe,MultiSelectDropdownListComponent],
    providers: [CaseSortWorkerService]
})
export class ViewQueuesOptimizedComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(MatSort) set matSort(ms: MatSort) {
        this.sort = ms;
        this.subscribeToSortChanges();
        this.setDataSourceAttributes();
        this.applySort();
    }
    @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
        this.paginator = mp;
        this.setDataSourceAttributes();
    }
    @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
    @ViewChildren(MatMenuTrigger) matMenuTriggers: MatMenuTrigger[];
    @ViewChild('actionMenu') actionMenu: MatMenu;
    @ViewChild('userInput', { read: MatAutocompleteTrigger }) userInput: MatAutocompleteTrigger;
    @ViewChild('assigneeDropdown') assigneeDropdown: MultiSelectDropdownListComponent;
    @ViewChild('clientDropdown') clientDropdown: MultiSelectDropdownListComponent;

    @Input() clientId;

    get settings() {
        return this.nbwStateService.getSavedSettings();
    }

    filterValue: any;
    menu: any = [];
    activeMenu: any = '';

    sort: MatSort;
    paginator: MatPaginator;

    clientUsers: ClientUser[] = [];
    queues: ManagementQueue[] = [];
    cases: ManagementQueueResult[] = [];
    dialogRef: MatDialogRef<NotesDialogComponent>;
    caseDataSource = new MatTableDataSource<ManagementQueueResult>();
    selectedQueue: ManagementQueue;
    selectedIndex: any = 0;
    timeZone: string;
    useSavedData = false;
    canAssignCase = false;
    canConfigure = false;
    selectedClients: UntypedFormControl;
    contextMenuPosition = { x: '0px', y: '0px' };
    selectedUser: UntypedFormControl;
    appServiceGetDataSub: any;
    columnsToDisplay = [];
    customColumns: string[] = [];
    selection: SelectionModel<ManagementQueueResult>;
    actionMenuTrigger: MatMenuTrigger;
    subscriptions: Subscription[] = [];
    filteredUserList: ClientUser[];
    assigneeSelectListItems: MultiSelectModel[];
    selectedAssignees: UntypedFormControl;
    onLoadSelectedAssigneesList: string[];
    onLoadSelectedClientsList: string[];
    queueDataLoaded = false;
    subs = new SubSink();
    columnMapkeys;
    initialSort = "caseCreated";
    initialSortDirection: SortDirection = '';

    showGetNextCase = false;
    selectedClientCode = '';
    readonly publicApiBaseUrl: string = '';
    getNextCaseIsLoaded = true;
    useEligibleAssigneesV2 = false;
    roles: any;
    visibleColumnMapKeys = [];

    private readonly filterDebounceMs = 200;
    private readonly filterValueChanged$ = new Subject<string>();
    private selectedQueueColumnKeyByDefinition: Record<string, string> = {};
    private selectedQueueDisplayNameByDefinition: Record<string, string> = {};
    private sortChangeSub: Subscription;
    isSorting = false;
    // The pre-sort, pre-filter (by assignee) row set that applySort() always sorts from.
    // Only filterCases() refreshes this - never applySort() itself - so repeated/cleared
    // sorting (e.g. clicking a column header a 3rd time) reverts to this pristine order
    // instead of re-sorting the previous sort's output.
    private sortBaseRows: ManagementQueueResult[] = [];

    constructor(
        public appService: AppService,
        public datePipe: DatePipe,
        public interviewService: InterviewService,
        public routingService: RoutingService,
        public activatedRoute: ActivatedRoute,
        public dialog: MatDialog,
        public monitoringService: MonitoringService,
        public nbwStateService: NewBusinessWorkbenchStateService,
        public clientService: ClientService,
        public caseAssigneeService: CaseAssigneeService,
        public notificationService: NotificationService,
        public snackBar: MatSnackBar,
        public utilityService: UtilityService,
        public globalService: GlobalService,
        public caseSummaryService: CaseSummaryService,
        public newBusinessWorkbenchService: NewBusinessWorkbenchService,
        public changeDetector: ChangeDetectorRef,
        private confirmationDialogService: ConfirmationDialogService,
        private featureManagerService: FeatureManagerService,
        public configService: IConfigService,
        private managementQueueService: ManagementQueueService,
        private caseSortWorkerService: CaseSortWorkerService
    ) {
        this.selection = new SelectionModel<ManagementQueueResult>(true, []);
        this.publicApiBaseUrl = this.configService.getConfiguration().publicApiUrl;
    }

    //#region Helpers

    getPresenceUsers(data: SearchCasesResults) {
        let result = null;
        if (data.presenceUsers && data.presenceUsers.length > 0) {
            result = Object.keys(data.presenceUsers).map(function (k) {
                return data.presenceUsers[k].name;
            }).join(', ');
        }
        return result;
    }


    HasValidRole(validRoles: RolesEnum[]) {
        const userRole = this.appService.getUserRoleName().toLowerCase();
        return validRoles.some(x => x.toLowerCase() === userRole);
    }

    //#endregion
    //#region Subscriptions

    subscribeAssignNextCaseToggle(): void {
        this.subs.add(this.featureManagerService.isEnabled(FeatureToggle.GlobalCaseManagerV2AssignNextCaseClient, this.clientId).subscribe(isEnabled => {
            this.showGetNextCase = isEnabled;

            if (!this.showGetNextCase) return;

            // Limit by client/role access
            if (this.clientId.toLowerCase() === Clients.AEG) {
                this.showGetNextCase = this.HasValidRole([RolesEnum.PNProcessor, RolesEnum.Processor, RolesEnum.Underwriter, RolesEnum.TIRepresentative]);
            }
            else if (this.clientId.toLowerCase() === Clients.RGA) {
                this.showGetNextCase = this.HasValidRole([RolesEnum.RgaUnderwriter]);
            }
            else if (this.clientId.toLowerCase() === Clients.AmFamPoC.toLowerCase()) {
                this.showGetNextCase = this.HasValidRole([RolesEnum.Supervisor, RolesEnum.CSR]);
            }
            else if (this.clientId.toLowerCase() === Clients.AmFam.toLowerCase()) {
                this.showGetNextCase = this.HasValidRole([RolesEnum.AmFamConversion, RolesEnum.AmFamFlexConversion]);
            }
        }));
    }

    //#endregion
    //#region Lifecycle

    ngOnInit() {
        this.appService.getAllConfigData();
        this.subs.add(this.globalService.getAllAssignees().subscribe(assignees => {
            const sortedAssignees = assignees.sort((a, b) => {
                const nameA = `${a.firstName?.toUpperCase()} ${a.lastName?.toUpperCase()}`;
                const nameB = `${b.firstName?.toUpperCase()} ${b.lastName?.toUpperCase()}`;
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            });
            this.assigneeSelectListItems = sortedAssignees.map(assignee => ({
                id: assignee.id,
                name: `${assignee.firstName} ${assignee.lastName}`,
                isSelected: false
            }));
        }));

        this.subscribeAssignNextCaseToggle();
        this.subs.add(this.featureManagerService.isEnabled(FeatureToggle.GlobalCaseManagerV2EligibleAssignees, this.clientId).subscribe(isEnabled => {
            this.useEligibleAssigneesV2 = isEnabled;
        }));
        
        
        $('#sidenav').removeClass('hidenav');

        if (this.nbwStateService.getSavedSettings()?.caseData) {
            this.useSavedData = true;
            this.queueDataLoaded = true;
        }

        this.nbwStateService.clientId = this.clientId;
        this.newBusinessWorkbenchService.startSignalRConnection(this.clientId);

        this.selectedUser = new UntypedFormControl('');
        this.selectedAssignees = new UntypedFormControl([]);

        this.subs.sink = this.filterValueChanged$.pipe(
            debounceTime(this.filterDebounceMs),
            distinctUntilChanged()
        ).subscribe((filterValue: string) => {
            this.caseDataSource.filter = (filterValue ?? '').trim().toLowerCase();
        });

        this.subs.sink = this.selectedUser.valueChanges.subscribe(val => {
            const filterValue = val ? val.toLowerCase() : '';

            if (this.clientUsers.length > 0) {
                this.filteredUserList = this.clientUsers.filter((item: ClientUser) => {
                    return (`${item.firstName} ${item.lastName}`.toLowerCase().includes(filterValue));
                });
                this.filteredUserList = _.sortBy(this.filteredUserList, ['firstName', 'lastName']);
            }
        });

        this.subs.sink = this.selectedAssignees.valueChanges.subscribe(val => {
            this.filterCases();
        });

        this.subs.sink = this.nbwStateService.queuesUpdated$.subscribe((queuesUpdatedMessage: ManagementQueueUpdates) => {
            this.queuesUpdated(queuesUpdatedMessage);
        });

        this.canAssignCase = this.checkACL('Allow Case Assignment', 'F');
        this.canConfigure = this.checkACL('Case Manager: Configure', 'W');

        this.queuesUpdated(this.nbwStateService.getNbwQueueUpdates());

        if (this.useSavedData) {
            this.getQueues();
        }
    }

    ngAfterViewInit() {
        this.updateUsingSavedSettings();

        this.actionMenuTrigger = this.matMenuTriggers.find(matMenuTrigger => matMenuTrigger.menu === this.actionMenu);
    }

    ngOnDestroy() {
        this.queues.forEach(x => x.isNewQueue = false);
        this.subs.unsubscribe();
        this.sortChangeSub?.unsubscribe();
        this.caseSortWorkerService.terminate();
        this.saveSettings();
    }

    //#endregion
    //#region Handlers

    viewCaseDetails(record, newTab = false) {
        this.caseSummaryService.routeToCase(record, newTab);
    }

    stopPropagation($event) {
        $event.stopPropagation();
    }

    openMenu(event: MouseEvent, record) {
        event.preventDefault();
        if (this.selection.selected.length === 0 || !this.selection.isSelected(record)) {
            this.selection.clear();
            this.selection.select(record);
        }
        this.contextMenuPosition.x = event.clientX + 'px';
        this.contextMenuPosition.y = event.clientY + 'px';
        this.actionMenuTrigger.openMenu();
    }

    selectQueue(tab: MatTabChangeEvent) {
        this.setSelectedQueue(tab.index);
    }

    selectedClientsChanged(newlySelectedClients: string[]) {
        this.selectedClients.setValue(newlySelectedClients);
    }

    selectedAssigneesChanged(newlySelectedAssignees: string[]) {
        this.selectedAssignees.setValue(newlySelectedAssignees);
    }

    onFilterChange(value: string) {
        this.filterValue = value;
        this.filterValueChanged$.next(value ?? '');
    }

    updateFilteredCases() {
        // Apply the filter directly instead of routing through filterValueChanged$: that subject's
        // distinctUntilChanged would suppress reapplying an unchanged search term to the new
        // MatTableDataSource created on queue switch, causing the search/filter to appear reset.
        if (this.filterValue) {
            this.caseDataSource.filter = this.filterValue.trim().toLowerCase();
        } else {
            this.caseDataSource.filter = null;
        }
    }

    editQueues() {
        this.routingService.navigateToRoute(RoutesEnum.caseManangerEdit);
    }

    getNextCase(): void {
        this.getNextCaseIsLoaded = false;
        this.subs.sink = this.managementQueueService.getNextCase(this.clientId).subscribe({
            next: (value: IGetNextCase) => {
                this.getNextCaseIsLoaded = true;
                if (value && JSON.stringify(value) !== '{}') {
                    this.routingService.navigateToUrl(`/client/${value.clientCode}/account/${value.accountCode}/${value.accountVersion}/${value.caseId}/summary`);
                }
                else {
                    const options: ConfirmationDialogData = {
                        title: 'No Cases Available',
                        message: 'Try again in a few minutes.',
                        okLabel: 'OKAY',
                        okTextColor: MrsColor.UIBlue
                    };
                    this.confirmationDialogService.open(options);
                }
            },
            error: (_err) => {
                this.getNextCaseIsLoaded = true;
            }
        });
    }

    openInNewWindow() {
        const selectedItems = this.getSelectedCases();

        if (selectedItems.length === 0) {
            this.appService.showMsg(NotificationSeverity.Warning, 'Select an item...');
            return;
        }

        selectedItems.forEach(record => {
            this.viewCaseDetails(record, true);
        });
    }

    viewNotes(item: any) {
        this.dialogRef = this.dialog.open(NotesDialogComponent, {
            width: '75%',
            data: item
        });
    }

    getClientUsers() {
        if (this.useEligibleAssigneesV2) {
            this.getClientUsersV2();
        } else {
            this.getClientUsersV1();
        }
    }

    getClientUsersV2() {
        const selectedCases = this.getSelectedCases();

        const parentAccountIds = selectedCases.map(item => item.parentAccountId)
            .filter((value, index, self) => self.indexOf(value) === index);

        this.clientUsers = [];
        if (!parentAccountIds || parentAccountIds.length === 0) {
            this.filteredUserList = [];
            return;
        }

        this.subs.sink = this.caseAssigneeService.getEligibleCaseAssigneesForMultipleAccounts(this.clientId, parentAccountIds).subscribe({
            next: (response: ClientUser[]) => {
                this.clientUsers = response;
            },
            complete: () => this.filteredUserList = _.sortBy(this.clientUsers, ['firstName', 'lastName'])
        });
    }

    getClientUsersV1() {
        const observableBatch: Observable<ClientUser[]>[] = [];
        const selectedCases = this.getSelectedCases();

        const clientIds = selectedCases.map(item => item.clientId)
            .filter((value, index, self) => self.indexOf(value) === index);

        this.clientUsers = [];
        clientIds.forEach(clientId => {
            observableBatch.push(this.clientService.getClientUsers(clientId));
        });

        this.subs.sink = forkJoin(observableBatch).subscribe({
            next: (responses) => {
                responses.forEach((response: ClientUser[]) => {
                    if (this.clientUsers.length === 0) {
                        this.clientUsers = response;
                    } else {
                        this.clientUsers = this.utilityService.compareTwoArrays(this.clientUsers, response, true);
                    }
                });
            },
            complete: () => this.filteredUserList = _.sortBy(this.clientUsers, ['firstName', 'lastName'])
        });
    }

    //#endregion

    setDataSourceAttributes() {
        this.caseDataSource.paginator = this.paginator;
    }

    // Refreshes the pristine, pre-sort row set that applySort() sorts from, and applies
    // the currently active sort (if any) on top of it. Call this whenever the underlying
    // (pre-sort) row set changes - e.g. filterCases() - never when only the sort direction
    // changes, otherwise clearing/re-sorting would operate on the previous sort's output.
    private setSortBaseRows(rows: ManagementQueueResult[]): void {
        this.sortBaseRows = rows ?? [];
        this.caseDataSource.data = this.sortBaseRows;
        this.applySort();
    }

    private subscribeToSortChanges(): void {
        this.sortChangeSub?.unsubscribe();

        if (this.sort) {
            this.sortChangeSub = this.sort.sortChange.subscribe(() => this.applySort());
        }
    }

    // Sorting the (potentially 7,000+ row) case list is offloaded to a Web Worker
    // (via CaseSortWorkerService) instead of MatTableDataSource's built-in synchronous
    // sortData, which was blocking the main thread/UI on large datasets.
    private applySort(): void {
        const rows = this.sortBaseRows;

        if (!this.sort || !rows || rows.length === 0) {
            return;
        }

        const sortActive = this.sort.active;
        const sortDirection = this.sort.direction;
        const useStrictValidation = this.useStrictDateValidation();

        this.isSorting = true;

        this.subs.sink = this.caseSortWorkerService.sort(
            rows,
            sortActive,
            sortDirection,
            this.selectedQueueColumnKeyByDefinition,
            useStrictValidation
        ).subscribe({
            next: sortedIndexes => {
                this.caseDataSource.data = sortedIndexes.map(index => rows[index]);
                this.saveSettings();
            },
            complete: () => this.isSorting = false,
            error: () => this.isSorting = false
        });
    }

    queuesUpdated(queuesUpdatedMessage: ManagementQueueUpdates) {
        if (queuesUpdatedMessage?.queuesUpdated || queuesUpdatedMessage?.queuesRemoved) {
            this.setupQueuesData(queuesUpdatedMessage.queues);
        }

        if (this.nbwStateService.getSavedSettings()?.selectedQueue == null && this.queues?.length > 0) {
            this.selectedIndex = 0;
            this.getCases(this.queues[0]);
        }

        this.nbwStateService.showQueuesMessage();
    }

    updateUsingSavedSettings() {
        if (this.nbwStateService.getSavedSettings()?.queues) {
            this.initialSort = this.nbwStateService.getSavedSettings().sortActiveColumn ?? this.initialSort;
            this.initialSortDirection = this.nbwStateService.getSavedSettings().sortDirection ?? '';
            this.selectedQueue = this.nbwStateService.getSavedSettings().selectedQueue;
            this.caseDataSource.data = this.nbwStateService.getSavedSettings().caseData;
            this.cases = this.nbwStateService.getSavedSettings().caseData;
            this.queues = this.nbwStateService.getSavedSettings().queues;
            this.selectedAssignees.setValue(this.nbwStateService.getSavedSettings().selectedAssignees);
            this.onLoadSelectedAssigneesList = this.nbwStateService.getSavedSettings().selectedAssignees;
            this.selectedIndex = this.nbwStateService.getSavedSettings().selectedQueue?.order - 1;
            this.filterValue = this.nbwStateService.getSavedSettings().filter;
            this.columnMapkeys = this.nbwStateService.getSavedSettings().columnMapkeys;
            this.applySort();
            this.updateFilteredCases();
        } else {
            this.nbwStateService.clearSettings();
            this.getQueues();
        }
    }

    checkACL(feature, permissionType) {
        return this.appService.checkACL(feature, permissionType);
    }

    setAttributes() {
        this.caseDataSource.paginator = this.paginator;

        if (this.nbwStateService.getSavedSettings() && this.paginator) {
            this.paginator.pageIndex = this.nbwStateService.getSavedSettings().pageIndex;
            this.paginator.pageSize = this.nbwStateService.getSavedSettings().pageSize;

            this.filterCases();
        }
    }

    getQueues() {
        this.subs.sink = this.newBusinessWorkbenchService.getFilteredWorkbenchQueues(this.clientId).subscribe(
            results => {
                const helper = results.filter(x => !x.isHidden);
                this.setupQueuesData(helper);
            }
        );
    }

    setupQueuesData(results: ManagementQueue[]) {
        this.queues = [...results].sort((a, b) => {
            if (a.order < b.order) return -1;
            if (a.order > b.order) return 1;
            return 0;
        });

        this.queueDataLoaded = true;
        this.columnMapkeys = [];
        const columns = [];

        this.queues.forEach(queue => {
            columns.push(...queue.managementQueueColumnMapKeys.filter(x => !Utils.isNullOrWhitespace(x.mapKeyName)));
        });

        this.columnMapkeys = _.uniqBy(columns, 'columnDefinition');

        if (this.nbwStateService.getSavedSettings()) {
            this.nbwStateService.getSavedSettings().queues = this.queues;
        }

        const currentlySelectedQueue = this.nbwStateService.getSavedSettings()?.selectedQueue;

        if (!this.nbwStateService.getSavedSettings()?.selectedQueue && this.queues.length > 0) {
            this.nbwStateService.clearSettings();
            this.nbwStateService.getSavedSettings().selectedQueue = this.queues[0];
            this.nbwStateService.getSavedSettings().caseData = null;
            this.useSavedData = false;

            setTimeout(function () {
                this.setSelectedQueue(0);
                this.getCases(this.nbwStateService.getSavedSettings().selectedQueue);
                this.selectedIndex = 0;
                this.changeDetector.markForCheck();
            }.bind(this), 0);
        } else {
            const idx = this.queues.findIndex(x => x.id === currentlySelectedQueue.id);
            this.selectedIndex = idx;
            this.setSelectedQueue(idx);
        }
    }

    getCases(queue: ManagementQueue) {
        this.selectedQueue = queue;
        this.selection.clear();
        if (this.useSavedData) {
            this.useSavedData = false;
            this.setAttributes();
        } else {
            this.caseDataSource = new MatTableDataSource<ManagementQueueResult>();
            this.configureDataSourceForQueue();
            const metricEvent = this.monitoringService.beginMetric(`Search: Case Manager-${this.selectedQueue?.name}`);

            // TECH DEBT: BUG?: The results from this call should be of of type `UWResponse<SearchCasesResults[]>` but
            // mapping `result.data` into a new model but that model doesn't fit the `ManagementQueueResult` format.
            this.subs.sink = this.appService.getData<UWResponse<SearchCasesResults[]>>(`CaseManager/Search/${queue.id}`, this.clientId).subscribe(results => {
                const searchResults = results.data ?? [];
                if (!searchResults || searchResults.length === 0) {
                    this.monitoringService.logEvent(`Search: Case Manager for queueId ${queue.id} - searchResults are empty`);
                }

                // TECH DEBT: We need to refactor this because it's a mess and typings aren't matching up. I think this entire component might
                // expect the bad typings to exist.
                this.cases = searchResults.map(c => ({
                    ...c,
                    canResume: this.interviewService.canResumeCase(c.status),
                    note: c.displayNote,
                    usersInCase: this.getPresenceUsers(c),
                    clientId: c.clientId,
                    checked: false,
                    ...c.mapkeys.reduce((dict, next) => {
                        dict[next.name] = next.value;
                        return dict;
                    }, {})
                })) as any;

                if (!this.cases || this.cases.length === 0) {
                    this.monitoringService.logEvent(`Search: Case Manager for queueId ${queue.id} - cases are empty`);
                }

                this.setDataSourceAttributes();

                if (this.sort) {
                    this.sort.active = this.nbwStateService.getSavedSettings().sortActiveColumn;
                    this.sort.direction = this.nbwStateService.getSavedSettings().sortDirection;
                }

                this.caseDataSource.data = this.cases;

                this.updateFilteredCases();
                this.saveSettings();

                this.filterCases();
                this.applySort();
                this.monitoringService.endMetric(metricEvent);
                this.monitoringService.flushMetrics();
            });
        }
    }

    getSortDirection(currentDirection) {
        if (currentDirection === 'asc') {
            return null;
        }

        if (currentDirection === 'desc') {
            return 'asc';
        }

        if (currentDirection === null) {
            return 'desc';
        }
    }

    sortUpdated($event) {
        this.saveSettings();
        this.filterCases();
    }

    setSelectedQueue(tabIndex: number) {
        const queue = this.queues[tabIndex];
        if (this.selectedQueue !== queue && this.selectedQueue) {
            this.selectedQueue.isNewQueue = false;
            this.selection.clear();
        }

        const sortedColumns = _.orderBy(queue.managementQueueColumnMapKeys, ['order']);
        const columns = sortedColumns.map(item => item.columnDefinition).filter((value, index, self) => self.indexOf(value) === index);
        this.columnsToDisplay = columns;
        
        this.visibleColumnMapKeys = sortedColumns.filter(column => !Utils.isNullOrWhitespace(column.mapKeyName));
        this.selectedQueueColumnKeyByDefinition = this.visibleColumnMapKeys.reduce((accumulator, column) => {
            accumulator[column.columnDefinition] = column.mapKeyName;
            return accumulator;
        }, {});
        this.selectedQueueDisplayNameByDefinition = sortedColumns.reduce((accumulator, column) => {
            accumulator[column.columnDefinition] = column.displayName;
            return accumulator;
        }, {});
        
        this.configureDataSourceForQueue();

        this.customColumns = columns.filter((value) => value !== 'selection');

        this.getCases(queue);
    }

    restartInterview(record) {
        this.routingService.navigateToRoute(RoutesEnum.interviewRestart, {
            clientCode: record.clientCode,
            accountCode: record.accountCode,
            versionNumber: record.accountVersionNumber,
            caseId: record.caseId
        });
    }

    saveSettings() {
        const settings = {
            caseData: this.cases,
            filter: this.filterValue,
            selectedClients: this.selectedClients?.value,
            selectedAssignees: this.selectedAssignees?.value,
            queues: this.queues,
            selectedQueue: this.selectedQueue,
            pageIndex: this.paginator?.pageIndex,
            pageSize: this.paginator?.pageSize,
            sortActiveColumn: this.sort?.active,
            sortDirection: this.sort?.direction,
            columnMapkeys: this.columnMapkeys
        };

        this.nbwStateService.saveSettings(settings);
    }


    filterCases() {
        const assigneeIds = this.selectedAssignees.value;
        const assigneeIdsLower = assigneeIds?.map((id: string) => id?.toLowerCase());

        let dataSource = this.nbwStateService.getSavedSettings() ? this.nbwStateService.getSavedSettings().caseData : this.caseDataSource.data;

        if (assigneeIdsLower?.length !== 0 && dataSource && dataSource !== null) {
            dataSource = dataSource.filter(caseData => assigneeIdsLower?.includes(caseData.assignedTo?.toLowerCase()));
        }

        this.setSortBaseRows(dataSource);
    }

    toggleAllSelection() {
        if (this.isAllSelected()) {
            this.selection.clear();
        } else {
            this.caseDataSource.filteredData.forEach(row => {
                if (!this.selection.isSelected(row)) {
                    this.selection.select(row);
                }
            });
        }
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.caseDataSource.filteredData.length;
        return numSelected === numRows;
    }

    getSelectedCases(): ManagementQueueResult[] {
        return this.selection.selected;
    }


    assignUser() {
        const user = this.clientUsers.find(x => x.id === this.selectedUser.value);
        const caseAssignees = this.buildCaseAssigneeList(user.id);
        const completedCases = [];
        const errorCases = [];

        this.subs.sink = this.caseAssigneeService.setCaseUserAssignee(caseAssignees).subscribe({
            next: response => {
                response.forEach(res => {
                    if (res.userErrors !== undefined) {
                        errorCases.push(res);
                    } else {
                        completedCases.push(res);
                    }
                });

                if (completedCases.length > 0 || errorCases.length > 0) {
                    this.toastCases(completedCases, errorCases);
                }

                this.clearSelection();

                this.useSavedData = false;
                this.getCases(this.selectedQueue);
            }
        });
    }

    public toastCases(completedCases: any[], errorCases: any[]) {
        const user = this.clientUsers.find(x => x.id === this.selectedUser.value);
        const toastMsgParts: string[] = [];

        if (completedCases.length > 0) {
            toastMsgParts.push(this.buildCompletedAssignmentMessage(completedCases, user));
            this.updateSelectedCaseAssignees(user);
        }

        if (errorCases.length > 0) {
            toastMsgParts.push(...this.buildErrorMessages(errorCases));
        }

        if (toastMsgParts.length > 0) {
            this.notificationService.showNotification({
                severity: NotificationSeverity.Info,
                message: toastMsgParts.join('. ')
            });
        }
    }

    private buildCompletedAssignmentMessage(completedCases: any[], user: ClientUser): string {
        const count = completedCases.length;
        return `${count} case${count > 1 ? 's have' : ' has'} been assigned to ${user.firstName} ${user.lastName}`;
    }

    private updateSelectedCaseAssignees(user: ClientUser): void {
        this.selection.selected.forEach(selectedCase => {
            selectedCase.assignedTo = user.id;
            selectedCase.assignedToFullName = `${user.firstName} ${user.lastName}`;
        });
    }

    private buildErrorMessages(errorCases: any[]): string[] {
        const messages: string[] = [];
        const duplicateAssignments = errorCases.filter(c =>
            Array.isArray(c.userErrors)
                ? c.userErrors.includes('This user has already been assigned to this case.')
                : c.userErrors === 'This user has already been assigned to this case.'
        );
        const otherErrorsCount = errorCases.length - duplicateAssignments.length;

        if (duplicateAssignments.length > 0) {
            const count = duplicateAssignments.length;
            messages.push(`${count} case${count > 1 ? 's' : ''} selected ${count > 1 ? 'are' : 'is'} already assigned to that user.`);
        }

        if (otherErrorsCount > 0) {
            messages.push(`${otherErrorsCount} case${otherErrorsCount > 1 ? 's' : ''} selected ${otherErrorsCount > 1 ? 'are' : 'is'} errored.`);
        }

        return messages;
    }

    buildCaseAssigneeList(userId?) {
        const caseAssignees: CaseAssignee[] = [];

        this.getSelectedCases().forEach(selectedCase => {
            const caseAssignee: CaseAssignee = {
                caseId: selectedCase.caseId,
                clientCode: selectedCase.clientId,
                userId: userId ?? selectedCase.assignedTo
            };

            caseAssignees.push(caseAssignee);
        });

        return caseAssignees;
    }

    claimCase() {
        const completedCases = [];

        const caseAssignees = this.buildCaseAssigneeList();

        this.subs.sink = this.caseAssigneeService.removeCaseUserAssignee(caseAssignees).subscribe(response => {
            if (!response || response.length === 0) {
                this.monitoringService.logEvent('claimCase during unassigment: Response is empty or null', { caseAssignees: JSON.stringify(caseAssignees) });
                return;
            }

            response.forEach(res => {
                completedCases.push(res);

                this.getCases(this.selectedQueue);
            });

            this.notificationService.showNotification({
                severity: NotificationSeverity.Success,
                message: `${completedCases.length} ${completedCases.length > 1 ? 'cases' : 'case'} cleared!`
            });

            this.selection.selected.forEach(selectedCase => {
                selectedCase.assignedTo = null;
            });
            this.clearSelection();
        });
    }

    canSelectedCasesBeAssign() {
        let areAllAssignable = true;
        this.selection.selected.forEach(selectedRow => {
            if (!selectedRow.canAssignTo) {
                areAllAssignable = false;
            }
        });

        return areAllAssignable;
    }

    clearSelection() {
        this.selection.clear();
        this.matMenuTriggers.forEach((matMenuTrigger) => matMenuTrigger.closeMenu());
        this.selectedUser.reset();
        this.userInput.closePanel();
    }

    getOptionText(option) {
        const user = this.clientUsers.find((clientUser) => clientUser.id === option);
        if (user) {
            return `${user.firstName} ${user.lastName}`;
        }
    }

    sortColumn(column: string) { /* intentionally no-op; column header click is handled by MatSort */ }

    getQueueTrackByFn() {
        return this.trackByQueueId.bind(this);
    }

    getColumnTrackByFn() {
        return this.trackByColumnDefinition.bind(this);
    }

    getCaseTrackByFn() {
        return this.trackByCaseId.bind(this);
    }

    trackByQueueId(index: number, queue: ManagementQueue): string {
        return queue?.id ?? `${index}`;
    }

    trackByColumnDefinition(index: number, column): string {
        return column?.columnDefinition ?? `${index}`;
    }

    trackByCaseId(index: number, row: ManagementQueueResult): string {
        return row?.caseId ?? `${index}`;
    }

    queueColumnDisplayName(columnDefinition: string): string {
        return this.selectedQueueDisplayNameByDefinition[columnDefinition] ?? '';
    }

    private configureDataSourceForQueue(): void {
        this.caseDataSource.filterPredicate = (data: ManagementQueueResult, filter: string): boolean => {
            if (!filter) {
                return true;
            }

            const matchedColumn = this.visibleColumnMapKeys.some(column => {
                const value = data[column.mapKeyName];
                return value != null && `${value}`.toLowerCase().includes(filter);
            });

            if (matchedColumn) {
                return true;
            }

            const noteText = ((data as any).note ?? (data as any).latestNoteContent ?? '').toString().toLowerCase();
            return noteText.includes(filter);
        };

        this.caseDataSource.sortingDataAccessor = (item: ManagementQueueResult, columnDefinition: string): string | number =>
            getCaseSortKey(item, columnDefinition, this.selectedQueueColumnKeyByDefinition, this.useStrictDateValidation());

        // Delegates to the same computeSortedIndexes() used by the Web Worker sort path
        // (CaseSortWorkerService/case-sort.utils.ts) so the sort-key/comparison logic isn't
        // duplicated between the main thread and the worker.
        this.caseDataSource.sortData = (data: ManagementQueueResult[], sort: MatSort): ManagementQueueResult[] => {
            const sortedIndexes = computeSortedIndexes(data, sort?.active, sort?.direction, this.selectedQueueColumnKeyByDefinition, this.useStrictDateValidation());
            return sortedIndexes.map(index => data[index]);
        };
    }

    private useStrictDateValidation(): boolean {
        return this.featureManagerService.getByName(FeatureToggle.CaseInterviewStrictDateValidation)?.enabled ?? false;
    }
}
